module.exports = new __parcel__URL__("connecting-waves.9140e0b9.svg").toString();